import { VRList } from '@/utils/type'

const videoPath = process.env.NEXT_PUBLIC_VIDEO_PATH ?? ''

export const vrList: VRList[] = [
  {
    id: '30294407-7e8d-43c1-9b95-f2b19a67656c',
    name: 'accel_1',
    vrSrc: `${videoPath}/accel_1.mp4`,
    yojyoType: ['accel'],
  },
  {
    id: '1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d',
    name: 'accel_2',
    vrSrc: `${videoPath}/accel_2.mp4`,
    yojyoType: ['accel'],
  },
  {
    id: '3c4d5e6f-7a8b-9c0d-1e2f-3a4b5c6d7e8f',
    name: 'engine_1',
    vrSrc: `${videoPath}/engine_1.mp4`,
    yojyoType: ['engine'],
  },
  {
    id: '4d5e6f7a-8b9c-0d1e-2f3a-4b5c6d7e8f90',
    name: 'engine_2',
    vrSrc: `${videoPath}/engine_2.mp4`,
    yojyoType: ['engine'],
  },
  {
    id: '6f7a8b9c-0d1e-2f3a-4b5c-6d7e8f901234',
    name: 'gasoline_1',
    vrSrc: `${videoPath}/gasoline_1.mp4`,
    yojyoType: ['gasoline'],
  },
  {
    id: '7a8b9c0d-1e2f-3a4b-5c6d-7e8f90123456',
    name: 'gasoline_2',
    vrSrc: `${videoPath}/gasoline_2.mp4`,
    yojyoType: ['gasoline'],
  },
  {
    id: '3c1io90b-a477-8f9a-plo9-4784a81a3c1i',
    name: 'spots.kayabukinosato.title',
    position: { x: 0.64, y: 0.85 },
    vrSrc: `${videoPath}/kayabukinosato.mp4`,
    yojyoType: ['engine'],
  },
  {
    id: '7uio8f9a-plo9-4784-a81a-3c1io90b1a47',
    name: 'spots.hakkoningen.title',
    position: { x: 0.44, y: 0.83 },
    vrSrc: `${videoPath}/hakkoningen.mp4`,
    yojyoType: ['accel'],
  },
  {
    id: 'a1f4128d-bab2-4a41-b72f-38384916f318',
    name: 'spots.university.title',
    position: { x: 0.36, y: 0.62 },
    vrSrc: `${videoPath}/open_campus.mp4`,
    yojyoType: [],
  },
  {
    id: 'b72f3838-4916-f318-a1f4-128d-bab2-4a41',
    name: 'spots.university.vr.acupuncture.subtitle',
    position: { x: 0.41, y: 0.62 },
    vrSrc: `${videoPath}/acupuncture.mp4`,
    yojyoType: [],
  },
  {
    id: 'c28d4916-f318-a1f4-128d-bab2-4a41-b72f',
    name: 'spots.university.vr.osteopathic.subtitle',
    position: { x: 0.46, y: 0.62 },
    vrSrc: `${videoPath}/osteopathic.mp4`,
    yojyoType: [],
  },
  {
    id: 'r674128d-jkj7-3r56-b72f-89904916f418',
    name: 'spots.miyamasatoyamasha.title',
    position: { x: 0.475, y: 0.748 },
    vrSrc: `${videoPath}/miyamasatoyamasha.mp4`,
    yojyoType: ['accel'],
  },
  {
    id: 'fdf17f6f-192e-4849-b19b-ee481a0a0b06',
    name: 'spots.kototaki.title',
    position: { x: 0.31, y: 0.47 },
    vrSrc: `${videoPath}/kototaki.mp4`,
    yojyoType: ['gasoline'],
  },
  {
    id: 'j9j07f6f-678u-0909-k90k-ee987a0a0b06',
    name: 'spots.rurikei.title',
    position: { x: 0.22, y: 0.26 },
    vrSrc: `${videoPath}/rurikei.mp4`,
    yojyoType: ['accel'],
  },
  {
    id: '5a0cb70f-9d03-40a4-9a28-78b4f0b0e8ca',
    name: 'spots.makechiku.title',
    position: { x: 0.3, y: 0.36 },
    vrSrc: `${videoPath}/make.mp4`,
    yojyoType: ['engine'],
  },
  {
    id: '2h3ij49i-5g06-70e4-3a67-67b4f0b0e8ok',
    name: 'spots.vrTourismAssociation.vr.ikimi_shrine.subtitle',
    position: { x: 0.39, y: 0.38 },
    vrSrc: `${videoPath}/ikimi_shrine.mp4`,
    yojyoType: [],
  },
]
